import { useTranslation } from 'next-i18next';
import { useId, VFC } from 'react';
import {
  FilterAvailabilityOptions,
  FilterOptions,
  FilterSortOptions,
} from '../interface';
import styles from './ItemFilter.module.scss';

type Props = {
  filterOptions: FilterOptions;
  onFilterChange(filterOptionChanges: Partial<FilterOptions>): void;
  closeFilter: () => void;
};

const ItemFilter: VFC<Props> = ({
  filterOptions,
  onFilterChange,
  closeFilter,
}: Props) => {
  const { t } = useTranslation();
  const id = useId();
  const sortOptions = {
    newest: t('filterSidebar.sort.select.listedAtDesc'),
    oldest: t('filterSidebar.sort.select.listedAtAsc'),
  };
  const availabilityOptions = {
    all: t('filterSidebar.availability.options.all'),
    sold: t('filterSidebar.availability.options.sold'),
    available: t('filterSidebar.availability.options.available'),
  };

  return (
    <div className={styles.itemFilter}>
      <div className={styles.title}>
        {t('filterSidebar.heading')}
        <button
          type="button"
          onClick={closeFilter}
          className={styles.sidebarCloseButton}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 18H16V16H3V18ZM3 13H13V11H3V13ZM3 6V8H16V6H3ZM21 15.59L17.42 12L21 8.41L19.59 7L14.59 12L19.59 17L21 15.59Z"
              fill="#323232"
            />
          </svg>
        </button>
      </div>

      <div className={styles.title}>
        {t('filterSidebar.availability.heading')}
      </div>
      <div className={styles.availabilityRadios}>
        {Object.entries(availabilityOptions).map(([key, value]) => (
          <div key={key} className="radio">
            <input
              id={`${id}_radio_${key}`}
              type="radio"
              value={key}
              checked={filterOptions.availability === key}
              onChange={(e) => {
                onFilterChange({
                  availability: e.target.value as FilterAvailabilityOptions,
                });
              }}
            />
            <label htmlFor={`${id}_radio_${key}`} className="radio-label">
              {value}
            </label>
          </div>
        ))}
      </div>

      <div className={styles.title}>{t('filterSidebar.sort.heading')}</div>
      <div className={styles.selectWrapper}>
        <select
          value={filterOptions.sort}
          onChange={(e) =>
            onFilterChange({
              sort: e.target.value as FilterSortOptions,
            })
          }
          className={styles.sortSelect}
        >
          {Object.entries(sortOptions).map(([key, label]) => (
            <option value={key} key={key}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ItemFilter;
